/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
import { useOnClickOutside } from "../../CommonMethods/OutsideClick";
export default function Dropdown({
    label,
    id,
    placeholder,
    value,
    index,
    options,
    handleOnChangeInput,
    disabled,
    emptyField,
    data_testid,
    filterScroll,
    obj,
    objKey,
    widthAuto
}
) {
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)
    const [isOpen, setisOpen] = useState(false);
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });

    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef?.current?.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom-40;
        //40px
        const dropdownHeight =dropdownRef.current.clientHeight;
    
        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight-22}px`;
        } else {
            dropdownRef.current.style.top = '105%';
        }
    };
    useEffect(() => {
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);
   
    return (
        <>
            <div className='relative' ref={ref}>
                <p htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</p>
                <button  ref={buttonRef} data-testid="select-device-btn"  onClick={() => setisOpen(!isOpen)} className={`border ${emptyField?'border-[#C81720]':'border-[#C5C9DA] '} rounded-lg px-3.5 py-[12px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center ${widthAuto ? 'w-auto' : 'min-w-max'}`} disabled={disabled} >
                    <p id= {id}className={`${placeholder!=="Day(s)"&&(value === "" || value === undefined || value === true ||value.length === 0)?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true||value.length === 0)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul className={`p-4 rounded-lg bg-white z-[9] absolute top-[72px] w-full min-w-max left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul className={`max-h-[390px] overflow-auto  ${filterScroll ? 'scrollbar_gray' : 'scrollBar_green'} `}>
                            {obj === undefined ?(
                                options?.map((option,i)=>(
                                    <li
                                        key={i}
                                        id={id}
                                        onClick={(e) => {
                                            handleOnChangeInput(id, option,index),
                                            setisOpen(false);
                                        }} 
                                    >
                                        <p className={` w-full inline-block cursor-pointer ${option===value?`text-base text-[#008586]`:'text-sm font-normal text-[#000]'} hover:text-[#008586] ${options.length-1 === i ? '' : 'mb-5' }`}>{option}</p>
                                    </li>
                                ))
                            )
                                :
                                (
                                    options?.map((option,i)=>(
                                        <li
                                            key={i}
                                            data-testid='device_template'
                                            id={id}
                                            onClick={(e) => {
                                                handleOnChangeInput(id, option,index),
                                                setisOpen(false);
                                            }} 
                                        >
                                            <p className={` w-full inline-block cursor-pointer ${option===value?`text-base text-[#008586]`:'text-sm font-normal text-[#000]'} hover:text-[#008586] ${options.length-1 === i ? '' : 'mb-3' }`}>{option[objKey]}</p>
                                        </li>
                                    ))
                                )}
                        </ul>
                    </li>
                </ul>             
            </div>
        </>
    )
}
